import { get_db } from '../http-worker/db-func';

const get_name = async (key: string, table_list: any, set_table_list: React.Dispatch<React.SetStateAction<any>>, items: any[] | undefined): Promise<void> => {
  if (items?.length) {
    const func = (selected_item_name: string | undefined) => {
      set_table_list((current_state: { [key: string]: any }): any => {
        current_state[key] = selected_item_name || items[0].id || '';
        return { ...current_state };
      });
    };
    await get_db([{ key, func, data: (table_list as { [key: string]: any })[key] }]);
  }
};

export default get_name;
